// Parallelbuchhaltung (INTERN / VORLAEUFIG) - Phase 3-5: Befunde aus den Kanzlei-Unterlagen, eigene SuSa/BWA, monatlicher Kanzleivergleich, Bereitschaft der Rueckrechnung.
// Nachgewiesenes, Vermutetes und Offenes (nur der Steuerberater kann es bestaetigen) sind getrennt dargestellt. Hier wird nichts uebermittelt und nichts angeglichen.
import { useState, useEffect, useCallback } from "react";
import THEME from "../../../../theme";
import { fs } from "../../utils/styles";
import { pbApi } from "../../../belege/belegeApi";
import { Karte, Klein, Chip, useAktion } from "../../../belege/ui";

const ymText = (ym) => `${String(ym).slice(4)}/${String(ym).slice(0, 4)}`;
const ymWert = (ym) => `${String(ym).slice(0, 4)}-${String(ym).slice(4)}`;
const wertYm = (s) => Number(String(s).replace("-", ""));
const zahl = (s) => (s === null || s === undefined ? "–" : Number(s).toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }));

// ------------------------------------------------------------------ Befunde + Bereitschaft
export function Befunde({ setFehler, setHinweis }) {
  const [d, setD] = useState(null);
  const [monate, setMonate] = useState([]);
  const [b, setB] = useState(null);
  const [von, setVon] = useState("2025-08");
  const [bis, setBis] = useState("2026-09");
  const aktion = useAktion(setFehler, setHinweis);
  useEffect(() => {
    pbApi.befunde().then(setD).catch(e => setFehler(e.message));
    pbApi.kanzleiMonate().then(r => { setMonate(r.monate); if (r.monate.length) setBis(ymWert(r.monate[r.monate.length - 1])); }).catch(() => {});
  }, [setFehler]);
  if (!d) return <div>Lädt…</div>;
  if (!d.vorhanden) return <Karte titel="Befunde"><Klein>Es sind keine Kanzlei-Auswertungen (BWA/SuSa) importiert.</Klein></Karte>;
  const liste = (titel, farbe, symbol, items) => items.length > 0 && (
    <div style={{ marginTop: 10 }}>
      <div style={{ color: farbe, fontWeight: 600, fontSize: THEME.fontSize.sm }}>{symbol} {titel}</div>
      <ul style={{ margin: "4px 0 0 18px", padding: 0, color: THEME.colors.text }}>{items.map((x, i) => <li key={i} style={{ marginBottom: 4 }}>{x}</li>)}</ul>
    </div>
  );
  return (
    <div>
      <Karte titel="Fachliche Befunde aus den Kanzlei-Unterlagen">
        <Klein>{d.hinweis} Datenbasis: {d.kanzlei_monate.anzahl} Monate ({ymText(d.kanzlei_monate.von)}–{ymText(d.kanzlei_monate.bis)}).</Klein>
      </Karte>
      {d.befunde.map(x => (
        <Karte key={x.id} titel={x.frage} rechts={<Chip text={x.einschaetzung} farbe={x.einschaetzung === "unklar" ? THEME.colors.warning : THEME.colors.accent} />}>
          {liste("Nachgewiesen (aus den Daten belegbar)", THEME.colors.success, "✅", x.nachgewiesen)}
          {liste("Vermutung (nicht bewiesen)", THEME.colors.warning, "💭", x.vermutung)}
          {liste("Offen – nur der Steuerberater kann es bestätigen", THEME.colors.danger, "❓", x.offen)}
        </Karte>
      ))}
      <Karte titel="Phase 5 – Bereitschaft der Rückrechnung (nur Prüfung, es wird nichts gebucht)">
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "end" }}>
          <label><span style={fs.label}>Von</span><input type="month" style={fs.input} value={von} onChange={e => setVon(e.target.value)} /></label>
          <label><span style={fs.label}>Bis</span><input type="month" style={fs.input} value={bis} onChange={e => setBis(e.target.value)} /></label>
          <button style={fs.btn} onClick={() => aktion(() => pbApi.bereitschaft(wertYm(von), wertYm(bis))).then(r => r && setB(r))}>Bereitschaft prüfen</button>
        </div>
        <Klein>Die Rückrechnung erfolgt zuerst an einer Testkopie und braucht Ihre ausdrückliche Freigabe. Im Live-Modus sind rückwirkende Buchungen gesperrt.</Klein>
        {b && (
          <div style={{ marginTop: 10 }}>
            <Chip text={b.bereit ? "Voraussetzungen erfüllt (Blocker)" : "NICHT bereit – Blocker offen"} farbe={b.bereit ? THEME.colors.success : THEME.colors.danger} />
            {b.punkte.map((p, i) => (
              <div key={i} style={{ padding: "6px 0", borderTop: `1px solid ${THEME.colors.border}` }}>
                {p.ok ? "✅" : p.blocker ? "⛔" : "⚠️"} <strong>{p.punkt}</strong><Klein>{p.detail}</Klein>
              </div>
            ))}
            {liste("Steuerliche Fragen, die noch offen sind", THEME.colors.danger, "❓", b.steuerliche_fragen_offen)}
          </div>
        )}
      </Karte>
      {monate.length === 0 && <Klein>Keine Kanzlei-Monate gefunden.</Klein>}
    </div>
  );
}

// ------------------------------------------------------------------ Eigene SuSa / BWA
export function Auswertung({ setFehler, setHinweis, teil }) {
  const aktion = useAktion(setFehler, setHinweis);
  const [monate, setMonate] = useState([]);
  const [ym, setYm] = useState(null);
  const [ohne, setOhne] = useState(false);
  const [susa, setSusa] = useState(null);
  const [bwa, setBwa] = useState(null);
  const [start, setStart] = useState(null);
  const [suche, setSuche] = useState("");
  useEffect(() => { pbApi.kanzleiMonate().then(r => { setMonate(r.monate); setYm(y => y || r.monate[r.monate.length - 1] || null); }).catch(() => {}); pbApi.startsalden().then(setStart).catch(() => {}); }, []);
  const laden = useCallback(() => {
    if (!ym) return;
    pbApi.susa(ym, ohne).then(setSusa).catch(e => setFehler(e.message));
    pbApi.bwa(ym, ohne).then(setBwa).catch(e => setFehler(e.message));
  }, [ym, ohne, setFehler]);
  useEffect(() => { laden(); }, [laden]);
  const vormonat = ym ? (ym % 100 === 1 ? (Math.floor(ym / 100) - 1) * 100 + 12 : ym - 1) : null;
  return (
    <div>
      <Karte titel={teil === "bwa" ? "Eigene BWA – vorläufig" : teil === "susa" ? "Eigene Summen- und Saldenliste (SuSa) – vorläufig" : "Eigene Summen- und Saldenliste (SuSa) und BWA – vorläufig"}>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "end" }}>
          <label><span style={fs.label}>Monat</span><input type="month" style={fs.input} value={ym ? ymWert(ym) : ""} onChange={e => e.target.value && setYm(wertYm(e.target.value))} /></label>
          <label style={{ color: THEME.colors.text }}><input type="checkbox" checked={ohne} onChange={e => setOhne(e.target.checked)} /> unsichere Buchungen ausblenden</label>
        </div>
        <Klein>Anfangssalden: {start?.stichtag ? `Stand ${start.stichtag} (${start.konten} Konten, aus der Kanzlei-SuSa)` : "keine – Salden der Bestandskonten sind dann nur Bewegungen"}.</Klein>
        {vormonat && monate.includes(vormonat) && (
          <button style={{ ...fs.btnGray, marginTop: 8 }} onClick={() => aktion(() => pbApi.startsaldenSetzen(vormonat), r => `Anfangssalden zum ${r.stichtag} aus der Kanzlei-SuSa übernommen (${r.konten} Konten).`).then(() => { pbApi.startsalden().then(setStart); laden(); })}>
            Anfangssalden aus Kanzlei-SuSa {ymText(vormonat)} übernehmen
          </button>
        )}
      </Karte>
      {bwa && teil !== "susa" && (
        <Karte titel={`BWA ${ymText(ym)} (Parallelbuchhaltung)`}>
          {Object.entries(bwa.positionen).map(([k, p]) => (
            <div key={k} style={{ display: "flex", justifyContent: "space-between", gap: 8, padding: "4px 0", fontWeight: p.summe ? 700 : 400, borderTop: p.summe ? `1px solid ${THEME.colors.border}` : "none" }}>
              <span>{p.bezeichnung}{!p.verifiziert && <span title="Zuordnung nicht an Kanzleidaten verifiziert" style={{ color: THEME.colors.textMuted }}> ◦</span>}</span>
              <span style={{ fontVariantNumeric: "tabular-nums", whiteSpace: "nowrap" }}>{Number(p.unsicher_anteil) ? <span style={{ color: THEME.colors.danger, fontWeight: 400, marginRight: 8 }}>davon unsicher {zahl(p.unsicher_anteil)}</span> : null}{zahl(p.monat)} <span style={{ color: THEME.colors.textMuted }}>({zahl(p.ytd)} seit 1.1.)</span></span>
            </div>
          ))}
          <Klein>◦ = Zuordnung der BWA-Position nicht an Kanzleidaten verifiziert. {bwa.hinweis}</Klein>
          {bwa.nicht_zugeordnet.length > 0 && <Klein farbe={THEME.colors.warning}>Erfolgskonten ohne BWA-Position: {bwa.nicht_zugeordnet.join(", ")}</Klein>}
        </Karte>
      )}
      {susa && teil !== "bwa" && (
        <Karte titel={`SuSa ${ymText(ym)} – ${susa.zeilen.length} Konten`} rechts={<Chip text={susa.ausgeglichen ? "Soll = Haben" : "NICHT ausgeglichen"} farbe={susa.ausgeglichen ? THEME.colors.success : THEME.colors.danger} />}>
          <input style={{ ...fs.input, width: "100%", maxWidth: 320, marginBottom: 8 }} placeholder="Konto oder Bezeichnung suchen" value={suche} onChange={e => setSuche(e.target.value)} />
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 8 }}>
            {susa.zeilen.filter(z => !suche || z.konto.includes(suche) || (z.bezeichnung || "").toLowerCase().includes(suche.toLowerCase())).map(z => (
              <div key={z.konto} style={{ border: `1px solid ${Number(z.unsicher_betrag) ? THEME.colors.danger : THEME.colors.border}`, borderRadius: THEME.radius.md, padding: "8px 10px" }}>
                <strong>{z.konto}</strong> <span style={{ color: THEME.colors.textSecondary }}>{z.bezeichnung || ""}</span>
                <div style={{ display: "flex", justifyContent: "space-between", fontVariantNumeric: "tabular-nums" }}><span>Soll {zahl(z.soll_monat)}</span><span>Haben {zahl(z.haben_monat)}</span></div>
                <div style={{ display: "flex", justifyContent: "space-between", fontVariantNumeric: "tabular-nums", color: THEME.colors.textSecondary }}><span>Saldo {zahl(z.saldo)} {z.saldo_richtung}</span><span>{z.buchungen} Buchungen</span></div>
                <Klein>{z.saldo_art}</Klein>
                {Number(z.unsicher_betrag) > 0 && <Klein farbe={THEME.colors.danger}>davon unsicher: {zahl(z.unsicher_betrag)}</Klein>}
              </div>
            ))}
          </div>
          <Klein>Summe Soll {zahl(susa.summe_soll_monat)} · Summe Haben {zahl(susa.summe_haben_monat)}</Klein>
        </Karte>
      )}
    </div>
  );
}

